export function getCurrentDate() {
  const d = Date.now();

  return formatDate(d);
}

function formatDate(date) {
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };
  return new Intl.DateTimeFormat("default", options).format(date);
}
